export const transactionSelector = state => state.importReport.transaction;